import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBullseye,
  faChartBar,
  faChartLine, faCoins,
  faHome,
  faMoneyBillTransfer,
  faMoneyBillWave,
  faSignOutAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/sidebar.css';

const Sidebar: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login', { replace: true });
  };

  return (
    <nav className="sidebar">
      <ul className="list-none p-0 m-0">
        <SidebarItem to="/home" icon={faHome} text="Home" />
        <SidebarDivider />
        <SidebarItem to="/dashboard" icon={faChartLine} text="Dashboard" />
        <SidebarItem to="/cashflow" icon={faMoneyBillTransfer} text="Cashflow" />
        <SidebarDivider />
        <SidebarItem to="/income/dashboard" icon={faCoins} text="Income" />
        <SidebarItem to="/expenses/dashboard" icon={faMoneyBillWave} text="Expenses" />
        <SidebarDivider />
        <SidebarItem to="/investments/dashboard" icon={faChartBar} text="Investments" />
        <SidebarItem to="/goals" icon={faBullseye} text="Goals" />
      </ul>
      <div className="absolute bottom-0 w-full list-none">
        <SidebarDivider />
        <SidebarItem to="/account" icon={faUser} text="Account" />
        <SidebarItem to="#" icon={faSignOutAlt} text="Log Out" onClick={handleLogout} />
      </div>
    </nav>
  );
};

interface SidebarItemProps {
  to: string;
  icon: IconDefinition;
  text: string;
  onClick?: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ to, icon, text, onClick }) => (
  <li className="sidebar-item">
    <Link 
      to={to} 
      className="sidebar-link" 
      onClick={onClick && ((e) => { e.preventDefault(); onClick(); })}
    >
      <div className="icon-container">
        <FontAwesomeIcon icon={icon} className="mx-auto" />
      </div>
      <span className="menu-text">{text}</span>
    </Link>
  </li>
);

const SidebarDivider: React.FC = () => (
  <li className="sidebar-divider" />
);

export default Sidebar;